// src/pages/admin/AmendmentOfObjectivesPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมแก้ไขวัตถุประสงค์บริษัท”
import AmendmentOfObjectivesForm from "../../forms/meeting/Meeting regarding Amendment of Objectives/MeetingregardingAmendmentofObjectives";

function AmendmentOfObjectivesPage() {
  return (
    <FormWrapper
      title="เชิญประชุมแก้ไขวัตถุประสงค์"
      FormComponent={AmendmentOfObjectivesForm}
      formKey="amendment-of-objectives"
    />
  );
}

export default AmendmentOfObjectivesPage;
